export default {
  computed: {
    displayOnlyShowButton () {
      if (this.$store.getters['security/hasRole']('ROLE_BBA_ADMIN')) return false
      return !!this.apiObject.getConf('adminAccessOnly')
    }
  }
}
